/**
 * The QR rendering half of `constellation-sdk`, imported without the rest of it.
 *
 * WHY NOT just `from 'constellation-sdk'`: the package's entry point re-exports
 * every module through tslib's `__exportStar`, a runtime loop over an object's
 * keys. There is nothing there for a bundler to tree-shake against, so importing
 * one function from the barrel pulls in the whole client — axios, the Supabase
 * client, every DTO. Measured, on the chunk that holds `lib/queries/mappers.ts`:
 * 32 kB raw / 8.6 kB gzipped via these paths, against 754 kB / 192 kB via the
 * barrel. That chunk is eagerly loaded by the workspace provider, so it is paid
 * on first paint by every screen.
 *
 * This covers `qr-code-style` ONLY, which states in its own header that it
 * deliberately depends on nothing — it just builds a plain options object. The
 * circular renderer is deliberately absent: it pulls `qrcode-generator`, and
 * re-exporting it here would put that in every chunk that touches a style. The
 * CommonJS modules underneath do not tree-shake, so what this file names is what
 * its importers pay for. `styled-qr.tsx` imports the circular renderer straight
 * from its own deep path instead, because that is the only place that draws one.
 *
 * The path points into `dist` because the SDK is compiled CommonJS with no
 * `exports` map — there is no subpath to address it by. It is listed in
 * `optimizeDeps.include` in `vite.config.ts`; without that the dev server serves
 * the CommonJS file raw and the browser rejects every named import from it. See
 * the long note there.
 *
 * Anything needing the SDK's HTTP client should still import the barrel. This
 * module is about the renderer, which is pure.
 */

export {
  DEFAULT_QR_SIZE,
  DEFAULT_QR_STYLE,
  MAX_CIRCULAR_QUIET_MODULES,
  MIN_CIRCULAR_QUIET_MODULES,
  buildQRCodeOptions,
  parseQRStyleConfig,
  qrStyleFingerprint,
  resolveFinderTypes,
  resolveQuietModules,
} from 'constellation-sdk/dist/client/modules/novas/qr-code-style'
